import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Getting Started", -1)
const _hoisted_3 = { class: "row g-5" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
            'card',
            'card-bordered',
            'bg-transparent',
            'border-2',
            'order-secondary',
          ])
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, "Tiada Rekod")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass([
              'card',
              'card-bordered',
              'bg-transparent',
              'border-2',
              'border-secondary',
            ])
}
const _hoisted_8 = { class: "card-body text-black p-0 m-8" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "text-truncate" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"d-flex flex-center flex-column bg-ispk-primary bg-gradient p-10 rounded-3\"><div class=\"text-center p-5\"><h2 class=\"text-white\">Tidak dapat mencari apa yang anda perlukan?</h2><span class=\"text-white\">Try this next steps:</span></div><div class=\"d-inline-flex align-items-end p-5 bg-light rounded-3\"><div class=\"btn btn-sm btn-icon btn-secondary me-5\"><i class=\"bi bi-headset text-primary\"></i></div><div class=\"d-flex flex-column\"><span class=\"fw-bold\">Hubungi Kami</span><small>Team kami sedia membantu anda</small></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
          [_vShow, _ctx.articles.length < 1]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-md-4"
          }, [
            _createVNode(_component_router_link, {
              to: {
            name: 'soalan-lazim',
            params: { category: this.$route.params.category, id: index },
          }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.summary), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_11
  ], 64))
}